import { scheduleHeaders } from './scheduleHeaders';

/**
 * Fields for react-spreadsheet-import.
 * Configured purely for column mapping and ingestion.
 * All data validation is handled centrally by VirtualValidationTable.
 */
export const rsiFields = [
  {
    label: scheduleHeaders.employerCode,
    key: scheduleHeaders.employerCode,
    fieldType: { type: 'input' as const },
    example: 'ABCD12345678',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Employer code is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Employer code must be alphanumeric with exactly 12 chars', level: 'error' as const, value: '^[A-Za-z0-9]{12}$' },
    // ],
  },
  {
    label: scheduleHeaders.month,
    key: scheduleHeaders.month,
    fieldType: { type: 'input' as const },
    example: 'January',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Month is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Month must be a valid month name (e.g. January)', level: 'error' as const, value: '^(January|February|March|April|May|June|July|August|September|October|November|December)$' },
    // ],
  },
  {
    label: scheduleHeaders.year,
    key: scheduleHeaders.year,
    fieldType: { type: 'input' as const },
    example: '2024',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Year is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Year must be 4 digits (YYYY)', level: 'error' as const, value: '^\\d{4}$' },
    // ],
  },
  {
    label: scheduleHeaders.staffId,
    key: scheduleHeaders.staffId,
    fieldType: { type: 'input' as const },
    example: 'EMP001',
    // validations: [
    //   { rule: 'regex' as const, errorMessage: 'Staff ID must be alphanumeric', level: 'error' as const, value: '^[A-Za-z0-9]*$' },
    // ],
  },
  {
    label: scheduleHeaders.rsapin,
    key: scheduleHeaders.rsapin,
    fieldType: { type: 'input' as const },
    example: 'PEN123456789012',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'RSA Pin is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'RSA Pin must start with TPEN (15 chars) or PEN (15 chars)', level: 'error' as (const), value: '^(TPEN\\d{11}|PEN\\d{12})$' },
    // ],
  },
  {
    label: scheduleHeaders.employeeName,
    key: scheduleHeaders.employeeName,
    fieldType: { type: 'input' as const },
    example: 'Smith John Doe',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Employee name is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: "Name must be Surname FirstName OtherName — no special chars except hyphen and apostrophe", level: 'error' as const, value: "^[A-Za-z'-]+(?:\\s[A-Za-z'-]+){1,2}$" },
    // ],
  },
  {
    label: scheduleHeaders.normalContributionEmployee,
    key: scheduleHeaders.normalContributionEmployee,
    fieldType: { type: 'input' as const },
    example: '5000.00',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Normal contribution (employee) is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number with up to 2 decimals', level: 'error' as const, value: '^(?!-)(?:\\d{1,3}(?:,\\d{3})*|\\d+)(?:\\.\\d{1,2})?$' },
    // ],
  },
  {
    label: scheduleHeaders.normalContributionEmployer,
    key: scheduleHeaders.normalContributionEmployer,
    fieldType: { type: 'input' as const },
    example: '5000.00',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Normal contribution (employer) is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number with up to 2 decimals', level: 'error' as const, value: '^(?!-)(?:\\d{1,3}(?:,\\d{3})*|\\d+)(?:\\.\\d{1,2})?$' },
    // ],
  },
  {
    label: scheduleHeaders.voluntaryContributionEmployee,
    key: scheduleHeaders.voluntaryContributionEmployee,
    fieldType: { type: 'input' as const },
    example: '1000.00',
    // validations: [
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number with up to 2 decimals, or empty', level: 'error' as const, value: '^(?:\\d{1,3}(?:,\\d{3})*(?:\\.\\d{1,2})?|\\d+(?:\\.\\d{1,2})?)?$' },
    // ],
  },
  {
    label: scheduleHeaders.voluntaryContributionEmployer,
    key: scheduleHeaders.voluntaryContributionEmployer,
    fieldType: { type: 'input' as const },
    example: '1000.00',
    // validations: [
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number with up to 2 decimals, or empty', level: 'error' as const, value: '^(?:\\d{1,3}(?:,\\d{3})*(?:\\.\\d{1,2})?|\\d+(?:\\.\\d{1,2})?)?$' },
    // ],
  },
  {
    label: scheduleHeaders.otherContribution,
    key: scheduleHeaders.otherContribution,
    fieldType: { type: 'input' as const },
    example: '500.00',
    // validations: [
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number, or empty', level: 'error' as const, value: '^(?:\\d{1,3}(?:,\\d{3})*(?:\\.\\d+)?|\\d+(?:\\.\\d+)?)?$' },
    // ],
  },
  {
    label: scheduleHeaders.total,
    key: scheduleHeaders.total,
    fieldType: { type: 'input' as const },
    example: '11500.00',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'Total amount is required', level: 'error' as const },
    //   { rule: 'regex' as const, errorMessage: 'Must be a non-negative number with up to 2 decimals', level: 'error' as const, value: '^(?!-)(?:\\d{1,3}(?:,\\d{3})*|\\d+)(?:\\.\\d{1,2})?$' },
    // ],
  },
  {
    label: scheduleHeaders.contributionType,
    key: scheduleHeaders.contributionType,
    fieldType: { type: 'input' as const },
    example: 'MAN',
  },
  {
    label: scheduleHeaders.pfaCode,
    key: scheduleHeaders.pfaCode,
    fieldType: { type: 'input' as const },
    example: 'PFA001',
    // validations: [
    //   { rule: 'required' as const, errorMessage: 'PFA code is required', level: 'error' as const },
    // ],
  },
] as const;

export type RsiRow = Record<string, string | boolean | undefined>;
